// extracted by mini-css-extract-plugin
export default {"component":"marketQuestionPage__component___uEsWq","top":"marketQuestionPage__top___vkbbz","bottom":"marketQuestionPage__bottom___b7ORz marketQuestionPage__top___vkbbz"};